import { render, staticRenderFns } from "./ViewParameters.vue?vue&type=template&id=70bfe762&"
import script from "./ViewParameters.vue?vue&type=script&lang=js&"
export * from "./ViewParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports